// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsCard,
  StatsTable,
  ScoreCard,
  StatsGraph,
  EarningGraph,
  Notifications,
  WorkProgress,
  TwitterFeed,
  TodoListDemo,
  TeamMatesDemo,
  AllGametypeTab
}                         from '../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../services/fetchTools';
import styles                 from './style';
import { Spinner } from 'react-activity';
import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../components';
import BatchHealthInfo from '../centerportal/batchHealthInfo';
import Card from '../../components/card/Card';
import DatePicker from 'react-datepicker';
import StatsWidget from '../../components/statsWidget/StatsWidget.js';
import StatsWidget2 from '../../components/statsWidget/StatsWidget2.js';
import styled from 'styled-components';
import moment from "moment";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
class Home extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
      fetchEarningGraphDataIfNeeded:  PropTypes.func,
      fetchTeamMatesDataIfNeeded:     PropTypes.func,
      fetchStatsWidgetDataIfNeeded:     PropTypes.func,
      fetchStatsWidget2DataIfNeeded:     PropTypes.func,
      fetchStatsCardDataIfNeeded:       PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      section:props.match.params.section,
      venue:props.statsTable.revenue_per_month.requested_venue_id,
      customer_data: [],
      customer_headers: [],
      revenue_data: [],
      revenue_headers: [],
      booking_data: [],
      booking_headers: [],
      source_booking_data:[],
      source_booking_headers:[],
      collection_data:[],
      collection_headers:[],
      active_cust: 1,
      date: moment(),
      source_date: moment(),
      customer: true,
      bookings: false,
      revenue: false,
      batch_health: false,
      session_health: false,
      program_date_changed: false,
      source_date_changed: false,
      collection:false,
      program: true,
      source: false,
      active_cust_count: 0,
      revenue_count: 0,
      booking_count: 0,
      collection_Stats:0,
      batches_count:0,
      excel_data:[],

    }
    this.handleSelection = this.handleSelection.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.locationChanged = this.locationChanged.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getStats()
    if(!this.state.section){
      this.setState({section:'RevenueDetails'});
    }
    const {
      actions: {
        fetchEarningGraphDataIfNeeded,
        fetchTeamMatesDataIfNeeded,
        fetchStatsWidgetDataIfNeeded,
        fetchStatsWidget2DataIfNeeded,
        fetchStatsCardDataIfNeeded,
        fetchStatsTableDataIfNeeded
      }
    } = this.props;
    $('.customer-trend').find("a").trigger("click");
    $('.revenue-trend').find("a").trigger("click");

    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }
  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      // this.getCustomers()       
      this.getBookings()     
      this.getStats()   
    })
  }
  handleSelection(event){
    const name = event.target.name;
    if(name == 'program'){
      this.setState({program:true,source:false})
    }
    else if(name == 'source'){
      this.setState({source:true,program:false})
    }
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }
  onTabClick(tabname){
    //TODO - commenting for now.
    this.props.history.push("/dashboard/" + tabname)
    this.setState({
      section: tabname,
    });

  }
  getStats() {
    const url = `${getLocationOrigin()}/cm/get_dashboard_stats/?venue=${this.state.venue}&source=${'partner'}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({active_cust_count:data.active_cust,revenue_count:data.revenue,booking_count:data.booking,batches_count:data.batches})
           // alert("fix");
       }).catch(error => error);
  }
  getBookings() {
    const date = this.state.date.format('YYYY-MM-DD');
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24622&venue_id=${this.state.venue}&date=${date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({booking_data:data.data,booking_headers:data.headers,program_date_changed:false,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }
  handleDate(date){
    this.setState({date:date,program_date_changed:true},()=>{this.renderBookings();});
  }
  renderBookings(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.booking_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.booking_headers.length; i++) {
        if(this.state.booking_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.booking_headers[i]);
          tab_index.push(i);
        }
      }
    }

    if(this.state.booking_data.length == 0 && this.state.booking_headers.length == 0 || this.state.program_date_changed){
      this.getBookings()
    }

    console.log('renderBookings')
    console.log(this.state.excel_data)
    
    return(
      <div>
      <div className='col-md-12 table_container1' style={styles.table}>
        <table className="table_plain">
          <tr> 
            { headers.map((head)=>
              <th style={{textAlign:'center'}}>{head}</th>
            )
          }
          </tr>
          
            { this.state.booking_data && this.state.booking_data.length > 0 ?
              this.state.booking_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.booking_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }

        </table>
      </div>
      <table id="table-to" style={{opacity:'0',height:'10%'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
      </table>
      </div>
      )
  }
  numberWithCommas(x) {
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return x.toLocaleString('en-IN');
  }
  render() {
    const {
      teamMates,
      teamMatesIsFetching,
      earningGraphLabels,
      earningGraphDatasets,
      statsWidget,
      statsWidget2,
      statsCard,
      statsGraph,
      scoreCard,
      statsTable
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    console.log('Dashboard props',this.props)

    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    // console.log('customer_data',this.state.customer_data)
    // const {
    //   statsTable,
    //   scoreCard,
    //   statsGraph,
    // } = this.props;

    // const {
    //   actions: {
    //     fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
    //   }
    // } = this.props;

    const cust_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'
    const book_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'
    const rev_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'

    const StyledRoot = styled.div`
      padding: 0px;
      display: flex;
      flex-direction: row;
      margin-Bottom:5px;
      `
    const StyledContainer = styled.div`
      width: 100%;
      padding:4px;
      
      `
    console.log(this.state)

    return(
      <div >
        <div className="breadcrumps" style={{'paddingLeft': "1%",'marginBottom':"1%"}}>
                        <a  onClick={() =>{this.onTabClick('RevenueDetails')}} >
                          <span>Dashboard</span>
                        </a>
                        {this.state.section == 'BookingDetails'  &&
                        <a  >
                          <span>Attendance</span>
                        </a> }
                        {this.state.section == 'BatchHealth'  &&
                        <a  >
                          <span>Batch Health</span>
                        </a> }
          </div>
        <div >
          <StyledRoot className="col-md-12">
              <StyledContainer >
                <Card
                  title="Customers & Revenue"
                  count={this.state.revenue_count > 0 ? this.numberWithCommas(this.state.revenue_count) : '-'}
                  action={"Contact"}
                  style={'#4daa0b'}
                  clicked= {this.state.section == 'RevenueDetails'}
                  onClick={() =>{this.onTabClick('RevenueDetails')}}
                />
              </StyledContainer>
          {/*<StyledContainer >
            <Card
              title="Attendance"
              count={this.state.booking_count > 0 ? this.numberWithCommas(this.state.booking_count) : '-'}
              action={"Contact"}
              style={'#4daa0b'}
              clicked= {this.state.section == 'BookingDetails'}
              onClick={() =>{this.onTabClick('BookingDetails')}}
            />
          </StyledContainer>*/}
  
          <StyledContainer >
            <Card
              title="Batch Health"
              action={"Contact"}
              count ={this.state.batches_count > 0 ? this.numberWithCommas(this.state.batches_count) :'-'}
              style={'#4daa0b'}
              clicked= {this.state.section == 'BatchHealth'}
              onClick={() =>{this.onTabClick('BatchHealth')}}
            />
          </StyledContainer>
          
        </StyledRoot>
        
        </div>

      <div className='col-md-12'>
        {this.state.section == 'RevenueDetails' &&
          <AnimatedView>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-6 revenue-trend">
                  <div style={{textAlign:'center',fontSize:18,textDecorationLine: 'underline'}}>Revenue Details</div>
                  {localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_bfc')
                      && localStorage.getItem('access') != 'Trespasser' ?
                    <StatsGraph type="bar" name="partner_revenue_details_graph_bfc" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                  :
                    <StatsGraph type="bar" name="partner_revenue_details_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                  }
                </div>
                
                <div className="col-md-6 customer-trend">
                  <div style={{textAlign:'center',fontSize:18,textDecorationLine: 'underline'}}>Customer Details</div>
                  {localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_bfc')
                      && localStorage.getItem('access') != 'Trespasser' ?
                    <StatsGraph type="bar" name="partner_revenue_cust_data_bfc" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                    :
                    <StatsGraph type="bar" name="partner_revenue_cust_data" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                  }
                </div>
              </div>  
              <div>
                {localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_bfc')
                      && localStorage.getItem('access') != 'Trespasser' ?
                  <StatsTable nonCollapsible = "true" bigTable={true} datefilter={false} end_date={false} name="partner_revenue_details_bfc" 
                        displayName="Customers & Revenue Details" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                  :
                  <StatsTable nonCollapsible = "true" bigTable={true} datefilter={false} end_date={false} name="partner_revenue_details" 
                      displayName="Customers & Revenue Details" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                }
              </div>
            </div> 
          </AnimatedView>
        }
        
        {
          this.state.section == 'BookingDetails' &&
            <div style={{marginTop:'1%'}}>
              {  this.renderBookings() }
            </div>
        }

        {
          this.state.section == 'BatchHealth' &&
            <BatchHealthInfo/>
        }          
      </div>  

      </div>
    );
  }



//   render() {
//     const {
//       teamMates,
//       teamMatesIsFetching,
//       earningGraphLabels,
//       earningGraphDatasets,
//       statsWidget,
//       statsWidget2,
//       statsCard,
//       statsGraph,
//       scoreCard,
//       statsTable
//     } = this.props;

//     const {
//       actions: {
//         fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
//       }
//     } = this.props;

//     return(
//       <AnimatedView>
//         <div className="row">
//         <div className="col-md-12 collection-trend">
//           <TabPanel>
//             <TabPanelHeader tabItems={this.state.rental_revenue_per_day_graph_tabs}/>
//             <TabPanelBody>
//               <TabPanelBodyContent id="1">
//                 <StatsTable name="court_usage_daily_data" data={statsTable} displayName="Daily Court Usage" reloadData={fetchStatsTableDataIfNeeded}/>
//               </TabPanelBodyContent>
//               <TabPanelBodyContent id="2">
//                 <StatsGraph type="line" name="court_usage_daily" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
//               </TabPanelBodyContent>
//             </TabPanelBody>
//           </TabPanel>
//         </div>  
        
//         </div> 

//         <div className="row">
//           <StatsTable nonCollapsible = "true" bigTable={true} datefilter={false} end_date={false} name="partner_revenue_details" displayName="Partner Revenue Details" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
//         </div>  


//       </AnimatedView>
//     );
//   }
// }
}

export default Home;



// WEBPACK FOOTER //
// ./src/app/views/home/Home.js